import { render } from "./IconSliders.vue?vue&type=template&id=04f18fa3&scoped=true"
const script = {}

import "./IconSliders.vue?vue&type=style&index=0&id=04f18fa3&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04f18fa3"]])

export default __exports__